import { cn } from "@/libs/utils";

type HeaderItemBoxProps = {
  title: string;
  value: string;
  className?: string;
  isLoading?: boolean;
};

export default function HeaderItemBox({
  title,
  value,
  className,
  isLoading,
}: HeaderItemBoxProps) {
  return (
    <div className="flex flex-col gap-[10px] p-5 bg-white border-gray-D border-[1px] rounded-xl">
      <p className="text-sm text-gray-B font-semibold">{title}</p>
      <p
        className={cn(
          "text-2xl text-dark-brown font-bold text-right",
          isLoading && "animate-pulse",
          className
        )}
      >
        {isLoading ? "-" : value}
      </p>
    </div>
  );
}
